import type { Section } from "../../../models/Section";
import type { MillId } from "@/setup/mill-config/mill-config";

export const SECTION_ASSET_LABEL = {
	MILL_1: "Mill #1",
	MILL_2: "Mill #2",
	SHARED: "Mill #1 / Mill #2",
} as const;

export type SectionAssetLabel =
	(typeof SECTION_ASSET_LABEL)[keyof typeof SECTION_ASSET_LABEL];

export interface SectionTableRow extends Section {
	Asset: SectionAssetLabel;
	MillIds: MillId[];
	SourceAssetId: MillId;
}
